import { listApplicationVersions } from '../../action/application-version'

export const settingsLoader = () => {

    listApplicationVersions()

}